<template>
    <ui-card-toggle
        v-if="teams?.global_active"
        design="brightness"
        :open="false"
    >
        <template #title>
            <div class="title-reservations">
                <ui-square-th-one />

                <span>Reservas - Limite por Equipe</span>
            </div>
        </template>

        <template #content>
            <ui-products-reserves-teams :teams="teams"  />
        </template>
    </ui-card-toggle>
</template>

<script>
import uiProductsReservesTeams from '@/components/ui-facilita/products/permissions/reserves/components/teams';
import { uiButton } from '@/components/ui/buttons';
import { uiCardToggle } from '@/components/ui/cards';

export default {
    name: 'ui-permissions-reservations-teams',

    components: {
        uiCardToggle,
        uiButton,
        uiProductsReservesTeams
    },

    props: {
        teams: {
            type: Object,
            default: () => {}
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>